import { Injectable, isDevMode, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/retry';
import { Observable, Subject } from 'rxjs/Rx';
import { WebsocketService } from './websocket.service';
import { DataStorageService } from './data-storage.service';
import { DialogsService } from './dialogs.service';

@Injectable()
export class ServerDataService implements OnDestroy {
  currentSocket: Subject<MessageEvent>;

  currentSocketAddress: string = "";

  logoutTimer;
  lastActiveTime: number = 0;
  currentTime: number = 0;
  timeoutTime: number = 3600;
  timeoutWarning = null;
  forcedLogout = false;

  waitingSubject: Subject<boolean>;

  private pictureName;
  private pictureType;
  private dataType;

  constructor(private wsService: WebsocketService,
    private dataStorage: DataStorageService,
    private router: Router,
    private dialogsService: DialogsService,
    private http: HttpClient) {
      this.waitingSubject = new Subject<boolean>();
      //this.dataStorage.setSessionItem("loggedin", "false");
      this.getCurrentSocketAddress().subscribe(data => {
        let msg = JSON.parse(JSON.stringify(data));
        this.currentSocketAddress = msg.serverAddress;
        this.createSpecificSocket(msg.serverAddress);
        this.waitingSubject.next(true);
      });
      this.logoutTimer = Observable.timer(0, 1000);
      this.logoutTimer.subscribe(x => {
        this.currentTime = x;
        this.checkLogoutTime();
      });
      if (!isDevMode()) {
        console.log = function(){};
      }
  }

  ngOnDestroy() {
    this.logoutTimer.unsubscribe();
    this.currentSocket.unsubscribe();
    this.waitingSubject.unsubscribe();
  }

  checkLogoutTime() {
    if (this.currentTime - this.lastActiveTime >= this.timeoutTime) {
      if (this.timeoutWarning != null) {
        this.timeoutWarning.close(false);
        this.timeoutWarning = null;
      }
      this.timeoutLogout();
    }

    if (this.currentTime - this.lastActiveTime == (this.timeoutTime - 300)) {
      if (this.router.isActive("login", true)) {
        this.activityChanges();
        this.logoutSocket();
      }
      else {
        this.timeoutWarning = this.dialogsService.logoutWarning("GENERAL.POPUPS.INACTIVITYHEADER", "GENERAL.POPUPS.INACTIVITYTEXT");
        this.timeoutWarning.afterClosed().subscribe(x => {
          this.activityChanges();
          this.timeoutWarning = null;
        });
      }
    }
  }

  timeoutLogout() {
    this.forcedLogout = true;
    this.router.navigate(["login"]);
    this.logoutSocket();
  }

  activityChanges() {
    this.lastActiveTime = this.currentTime;
  }

  createSocket() {
    this.currentSocket = this.wsService.connect(this.currentSocketAddress);
  }

  createSpecificSocket(socket: string) {
    this.currentSocket = this.wsService.connect(socket);
  }

  logoutSocket() {
    this.activityChanges();
//    this.dataStorage.setSessionItem("loggedin", "false");
//    this.dataStorage.loggedIn = false;
//    this.dataStorage.removeSessionItem("token");
//    this.dataStorage.removeSessionItem("userId");

    this.currentSocket = this.wsService.reconnect(this.currentSocketAddress);
  }

  getConnection() {
    if (this.wsService.isSocketClosed()) {
      console.log("Socket was closed. Reconnecting...");

      this.currentSocket = this.wsService.reconnect(this.currentSocketAddress);
    }
    return this.currentSocket;
  }

  isSocketClosed() {
    return this.wsService.isSocketClosed();
  }

  getCurrentSocketAddress() {
    return this.http.get("../assets/serverInfo.json");
  }

  sendData(data) {
    this.activityChanges();
    if (!this.isSocketClosed()) {
      this.currentSocket.next(data);
    }
    else {
      this.getConnection().next(data);
    }
  }

  sendPicture(data, type) {
    this.activityChanges();
    this.pictureName = data.name;
    this.pictureType = data.type;
    this.dataType = type;
    this.handleFileSelect(data);
  }

  sendFile(data, type, idKey, additionalData) {
    this.activityChanges();
    this.handleFile(data, type, idKey, additionalData)
  }

  handleFile(data, type, idKey, additionalData) {
    let file = data;
    if (file) {
      let reader = new FileReader();
      reader.onload = (event) => {
        let workaround: any = event
        this.uploadFile(type, data.name, workaround.target.result, data.type, idKey, additionalData);
      };
      reader.readAsDataURL(file);
    }
  }

  handleFileSelect(evt){
    var file = evt;

    if (file) {
      var reader = new FileReader();

      reader.onload =this._handleReaderLoaded.bind(this);

      reader.readAsBinaryString(file);
    }
  }

  _handleReaderLoaded(readerEvt) {
    var binaryString = readerEvt.target.result;
    this.uploadPicture(this.pictureType, this.pictureName, btoa(binaryString), this.dataType);
  }

  uploadPicture(type: string, name: string, data: string, dataType) {
    let limit: number = 50000;
    let tempData: string = data;
    let dataParts: string[] = [];

    for (let i = 0; i < tempData.length; i += limit) {
      dataParts.push(tempData.slice(i, i+limit));
    }

    for (let i = 0; i < dataParts.length; i++) {
      let lastPart = (i == (dataParts.length - 1));
      let imageData =
      {
        "id": "6d6a876b-c89c-4ea6-ab86-986835d2c659",
        "type": dataType,
        "awaitingResponse": lastPart,
        "body":
        {
          "image":
          {
            "id": "",
            "mimeType": type,
            "fileName": name,
            "totalNumberOfParts": dataParts.length,
            "partNo": i+1,
            "imageData": dataParts[i]
          }
        }
      };
      this.sendData(imageData);
    }
  }

  uploadApplicantPicture(type: string, name: string, data: string, dataType: string, applicantId: string) {
    let limit: number = 50000;
    let tempData: string = data;
    let dataParts: string[] = [];

    for (let i = 0; i < tempData.length; i += limit) {
      dataParts.push(tempData.slice(i, i+limit));
    }

    for (let i = 0; i < dataParts.length; i++) {
      let lastPart = (i == (dataParts.length - 1));
      let imageData =
      {
        "id": "6d6a876b-c89c-4ea6-ab86-986835d2c659",
        "type": dataType,
        "awaitingResponse": lastPart,
        "body":
        {
          "applicantId": applicantId,
          "image":
          {
            "id": "",
            "mimeType": type,
            "fileName": name,
            "totalNumberOfParts": dataParts.length,
            "partNo": i+1,
            "imageData": dataParts[i]
          }
        }
      };
      this.sendData(imageData);
    }
  }

  checkIfAllowedPicture(data: any): boolean {
    if (data.type == "image/jpeg" || data.type == "image/jpg" || data.type == "image/png") {
      return true;
    }
    else {
      return false;
    }
  }

  uploadFile(type: string, name: string, data: string, dataType: string, idKey: string, bookingId: string) {
    let limit: number = 50000;
    let tempData: string = data;
    let metaLength = 13 + dataType.length;
    tempData = tempData.slice(metaLength);
    let dataParts: string[] = [];


    for (let i = 0; i < tempData.length; i += limit) {
      dataParts.push(tempData.slice(i, i+limit));
    }

    for (let i = 0; i < dataParts.length; i++) {
      let lastPart = (i == (dataParts.length - 1));
      let fileData =
      {
        "id":"6d6a876b-c89c-4ea6-ab86-986835d2c659",
        "type": type,
        "awaitingResponse":lastPart,
        "body": {
          "file": {
            "mimetype" : dataType,
            "fileData" : dataParts[i],
            "filename": name,
            "fileDescription": name,
            "partNo" : i+1,
            "totalNumberOfParts" : dataParts.length
          },
          [idKey] : bookingId
        }
      };
      console.log(fileData);
      this.sendData(fileData);
    }
  }

  getBlobFromBase64(base64Data: {part: number, data: string}[], contentType: string): any {
    let combined = "";
    let ordered = base64Data.sort((a, b) => {return a.part - b.part;});

    for (let i = 0; i < ordered.length; i++) {
      combined += ordered[i].data;
    }
    return this.base64toBlob(combined, contentType);
  }

  base64toBlob(base64Data, contentType) {
    contentType = contentType || '';
    var sliceSize = 1024;
    var byteCharacters = atob(base64Data);
    var bytesLength = byteCharacters.length;
    var slicesCount = Math.ceil(bytesLength / sliceSize);
    var byteArrays = new Array(slicesCount);

    for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
        var begin = sliceIndex * sliceSize;
        var end = Math.min(begin + sliceSize, bytesLength);

        var bytes = new Array(end - begin);
        for (var offset = begin, i = 0 ; offset < end; ++i, ++offset) {
            bytes[i] = byteCharacters[offset].charCodeAt(0);
        }
        byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    return new Blob(byteArrays, { type: contentType });
}

}



// WEBPACK FOOTER //
// ./src/app/server-data.service.ts